import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateUserDetails } from "../../Redux/Actions/userAction";

const EditProfile = ({ toggleEditModal, user }) => {
  const dispatch = useDispatch();

  const [fullName, setFullName] = useState(user?.fullname);
  const [phone, setPhone] = useState(user?.phone);
  const [email, setEmail] = useState(user?.email);
  const [gender, setGender] = useState(user?.gender);
  const [DOB, setDOB] = useState(user?.date_of_birth);

  function handleUpdateProfile() {
    const updateData = {
      fullname: fullName,
      gender: gender,
      email: email,
      DOB: DOB,
      phone: phone,
    };

    dispatch(updateUserDetails(updateData));
    toggleEditModal();
  }

  return (
    <div className="bg-slate-800 bg-opacity-50 absolute inset-0 p-5">
      <div class=" flex justify-center items-center sticky top-0 right-0 bottom-0 left-0">
        <div class="relative bg-white px-16 py-14 rounded-md text-center">
          <h1 class="text-xl mb-4 font-bold text-slate-500">Edit Profile</h1>
          <button
            onClick={toggleEditModal}
            class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
          >
            <svg
              class="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>

          <div>
            <div className="relative z-0 w-full mb-6 group">
              <input
                type="email"
                name="floating_email"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2  appearance-none border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=""
                required=""
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label
                for="floating_email"
                className="peer-focus:font-medium absolute text-sm text-gray-500  duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Email Id
              </label>
            </div>
            <div className="relative z-0 w-full mb-8 group">
              <input
                type="text"
                name="fullname"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2  appearance-none border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required=""
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <label
                for="fullname"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Full Name
              </label>
            </div>
            <div className="relative z-0 w-full mb-6 group">
              <input
                type="number"
                name="floating_email"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2  appearance-none border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required=""
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <label
                for="floating_email"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
              >
                Phone Number
              </label>
            </div>

            <div className="w-full grid md:grid-cols-2 gap-2 mb-4 ">
              <div>
                <select
                  id="underline_select"
                  value={gender}
                  class="block py-2.5 px-0 w-full text-sm text-gray-800 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option selected className="text-black">
                    {" "}
                    Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Other</option>
                </select>
              </div>

              <div class="relative">
                <input
                  datepicker-buttons
                  type="date"
                  value={DOB}
                  class="bg-gray-50 border  border-black text-gray-900 sm:text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full  p-2.5   "
                  placeholder="Select date"
                  onChange={(e) => setDOB(e.target.value)}
                />
              </div>
            </div>

            <button
              onClick={handleUpdateProfile}
              className="text-white mb-4 bg-jet hover:bg-jet/90 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center "
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
